<template>
    <el-form :model="formModel" :rules="rules" ref="dataForm">
        <el-form-item label="名称:" prop="name" :label-width="formLabelWidth">
            <el-input
                v-model="formData.name"
                placeholder="请输入名称"
                autocomplete="off"
            ></el-input>
        </el-form-item>
        <el-form-item
            label="是否显示AI资源点:"
            prop="allRealName"
            :label-width="formLabelWidth"
        >
            <el-select placeholder="请选择" v-model="jsonObject.allRealName">
                <el-option label="是" :value="1"></el-option>
                <el-option label="否" :value="0"></el-option>
            </el-select>
        </el-form-item>
    </el-form>
</template>

<script>
export default {
    name: "ShowAiResourceUsage",
    props: ["initData"],
    watch: {
        jsonObject: {
            handler(newVal, oldVal) {
                this.formData.jsonStr = JSON.stringify(newVal);
            },
            deep: true,
        },
        initData: function (newVal, oldVal) {
            if (!newVal) return;
            // 新增时（无 id）用 newVal 完全重置，避免残留上一条信息
            const isAdd =
                newVal.id === undefined ||
                newVal.id === null ||
                newVal.id === "";
            if (isAdd) {
                this.formData.name =
                    newVal.name !== undefined && newVal.name !== null
                        ? newVal.name
                        : "";
                this.formData.jsonStr = newVal.jsonStr || "{}";
                this.formData.id = newVal.id;
                this.formData.type = newVal.type;
            } else {
                this.formData = Object.assign({}, this.formData, newVal);
                if (this.formData.name === undefined) {
                    this.formData.name = "";
                }
            }
            let parsedJson = {};
            if (newVal.jsonStr) {
                try {
                    parsedJson = JSON.parse(newVal.jsonStr);
                } catch (e) {
                    parsedJson = {};
                }
            }
            // 初始化 allRealName 字段，如果不存在则设置默认值
            if (parsedJson.allRealName === undefined) {
                parsedJson.allRealName = 0;
            }
            // 使用 Object.assign 确保响应式
            Object.assign(this.jsonObject, parsedJson);
        },
    },
    data() {
        let parsedJson = {};
        const init = this.initData || { jsonStr: "{}" };
        if (init.jsonStr) {
            try {
                parsedJson = JSON.parse(init.jsonStr);
            } catch (e) {
                parsedJson = {};
            }
        }
        // 初始化 allRealName 字段，如果不存在则设置默认值
        if (parsedJson.allRealName === undefined) {
            parsedJson.allRealName = 0;
        }
        const formData = {
            name:
                init.name !== undefined && init.name !== null ? init.name : "",
            jsonStr: init.jsonStr || "{}",
            id: init.id,
            type: init.type,
        };
        return {
            formData,
            jsonObject: parsedJson,
            formLabelWidth: "110px",
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入名称",
                        trigger: "blur",
                    },
                ],
                allRealName: [
                    {
                        required: true,
                        message: "请选择是否全部实名",
                        trigger: "change",
                    },
                ],
            },
        };
    },
    computed: {
        formModel() {
            return {
                name: this.formData.name,
                allRealName: this.jsonObject.allRealName,
            };
        },
    },
};
</script>

<style scoped>
</style>
